/**
 * 检验是否是整数
 * @param {number|string} val
 */
export function isInteger(val) {
  return /^-?([0-9]{1,})$/.test(val)
}

/**
 * 检验是否是正整数
 * @param {number|string} val
 */
export function isPositiveInteger(val) {
  return /^([0-9]{1,})$/.test(val)
}

/**
 * 检验是否是负整数
 * @param {number|string} val
 */
export function isNegativeInteger(val) {
  return /^-([0-9]{1,})$/.test(val)
}

/**
 * 检验是否是小数
 * @param {number|string} val
 */
export function isDecimal(val) {
  return /^-?([0-9]{1,}[.][0-9]*)$/.test(val)
}

/**
 * 检验是否是正小数
 * @param {number|string} val
 */
export function isPositiveDecimal(val) {
  return /^([0-9]{1,}[.][0-9]*)$/.test(val)
}

/**
 * 检验是否是负小数
 * @param {number|string} val
 */
export function isNegativeDecimal(val) {
  return /^-([0-9]{1,}[.][0-9]*)$/.test(val)
}

/**
 * 检验仅支持数字、字母、下划线
 * @param {number|string} value
 */
export function isValidateName(val) {
  return /^[a-zA-Z0-9_]*$/.test(val)
}

/**
 * 检验仅支持数字、字母、下划线
 * @param {number|string} value
 */
export function validateName(rule, value, callback) {
  if (value.length === 0 || !isValidateName(value)) {
    callback(new Error(this.$t('playTurbo.whole.validateMessage')))
  }
  return callback()
}

export function makeEven(number) {
  // 判断当前数字是奇数还是偶数
  if (number % 2 === 0) {
    // 如果是偶数，直接返回
    return number
  }
  // 如果是奇数，将其减一变为偶数
  return number - 1
}
